@import (reference) '../../../../../../constants/spacing.module.less';

.blacklist-table {
  width: 100%;
}

.table-container {
  overflow-x: auto;

  .actions-cell {
    justify-content: center;

    .actions-dropdown {
      background-color: inherit;
      border: none;
    }

    .icon-wrapper {
      color: var(--grey-500);
      cursor: pointer;
      padding: @space-4;

      &:hover {
        color: var(--grey-700);
      }

      svg {
        width: 16px;
      }
    }
  }
}

.empty-row {
  padding: @space-48 @space-24;
  text-align: center;
  align-items: center;
  gap: @space-8;
}
